module.exports = __webpack_public_path__ + "static/img/water3.dc035467.webp";